import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const VACANCIES = (params) =>
  URI(`${API_BASE}/api/v2/marketplace/key_sourcing_tool/vacancies/`).addSearch(params)
export const VACANCY = (id) => `${API_BASE}/api/v2/marketplace/key_sourcing_tool/vacancies/${id}/`
export const ROLE_AREAS = `${API_BASE}/api/v2/marketplace/key_sourcing_tool/roles_areas/`
